import { Observable, switchMap, map } from 'rxjs';

export function creatorWithAttachments<T>(api: {
  create(input: T): Observable<{ id: string }>;
  attach(id: string, attachments: File[]): Observable<void>;
}): (input: T, attachments: File[]) => Observable<string> {
  return (input, attachments) =>
    api
      .create(input)
      .pipe(
        switchMap((res) =>
          api.attach(res.id, attachments).pipe(map(() => res.id)),
        ),
      );
}

export function updaterWithAttachments<T>(api: {
  update(id: string, input: T): Observable<void>;
  attach(id: string, attachments: File[]): Observable<void>;
}): (id: string, input: T, newAttachments: File[]) => Observable<void> {
  return (id, input, newAttachments) =>
    api.update(id, input).pipe(switchMap(() => api.attach(id, newAttachments)));
}
